import 'moment/locale/pl'

import moment from 'moment'

import { selectLanguageBasedOnBrowserLocale } from './localeUtils'

if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', selectLanguageBasedOnBrowserLocale())
}

moment.locale(localStorage.getItem('i18nextLng'))

export const setLocale = lang => moment.locale(lang)

export default moment

window.moment = moment
